export default "Let's start by defining generative AI.\nWhat do we mean by generative AI?\nWe mean some computer program, that can create things from text\n"